import React, { Component } from 'react';
import { ImageType } from '../types/image.type';

class Image extends Component<ImageType> {
  render ()  {
    const {src, alt, width, height} = this.props;
    return <div className='img-wrapper'>
      <img src={src} alt={alt} loading="lazy" width={width} height={height}/>
    </div>
  };
}
export default Image;
